<template>
  <div class="pendientes-envasado container mt-4 p-4 bg-white rounded shadow-sm">
    <h3 class="mb-4 text-pendiente">
      <font-awesome-icon icon="box-open" class="me-2" />
      Productos Final Bulk Pendientes de Envasado
    </h3>

    <div v-if="loading" class="text-center my-5">
      <div class="spinner-border text-warning" role="status">
        <span class="visually-hidden">Cargando...</span>
      </div>
    </div>

    <div v-else>
      <div v-if="pendientes.length === 0" class="alert alert-light border border-warning text-warning">
        No hay productos finales bulk pendientes de envasado.
      </div>

      <div v-else class="row g-3">
        <div class="col-12 col-sm-6 col-md-4 col-lg-3" v-for="producto in pendientes" :key="producto.id">
          <div class="card h-100 shadow-sm border border-warning">
            <div class="card-header bg-pendiente text-white d-flex justify-content-between align-items-center">
              <strong>#{{ producto.id }}</strong>
              <small>{{ formatDate(producto.fecha_produccion) }}</small>
            </div>

            <div class="card-body">
              <p class="mb-2"><strong class="text-muted">Materia Prima:</strong><br> {{ producto.materia_prima?.codigo
                || '-' }}</p>
              <p class="mb-2"><strong class="text-muted">Tipo Producto:</strong><br> {{ producto.tipo_producto }}</p>
              <p class="mb-0"><strong class="text-muted">Lote Producción:</strong><br> {{ producto.codigo }}</p>
            </div>

            <div class="card-footer text-end">
              <button class="btn btn-pendiente btn-sm" @click="envasar(producto)">
                <font-awesome-icon icon="box" class="me-1" />
                Envasar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>


<script>
import axios from '@/axios';
import { format } from 'date-fns';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  name: 'ListaPendientesEnvasado',
  components: { FontAwesomeIcon },
  data() {
    return {
      pendientes: [],
      loading: false,
      clubActual: this.$store.getters.getClubActual
    };
  },
  methods: {
    async fetchPendientes() {
      this.loading = true;
      try {
        const res = await axios.get('/api/producto_final_bulk', {
          params: { club_id: this.clubActual.id }
        });

        // Filtrar los que no tienen envasados
        this.pendientes = res.data.filter(b => (b.envasados || []).length === 0);

      } catch (error) {
        console.error('Error al obtener bulk pendientes:', error);
        this.pendientes = [];
      } finally {
        this.loading = false;
      }
    },

    formatDate(date) {
      return format(new Date(date), 'dd/MM/yyyy');
    },

    envasar(producto) {
      this.$emit('viewChange', { view: 'procesar', productoFinalBulk: producto });
    }
  },
  mounted() {
    this.fetchPendientes();
  }
};
</script>






<style scoped>
.pendientes-envasado {
  background: #fff;
  padding: 25px;
  border-radius: 12px;
  box-shadow: 0 0 12px rgba(0, 0, 0, 0.05);
}

.text-pendiente {
  color: #d18f00;
  /* ambar oscuro */
}

.bg-pendiente {
  background-color: #d18f00;
}

.table thead th {
  font-weight: 600;
  font-size: 0.9rem;
}

.table tbody tr:hover {
  background-color: #fdf5e6;
}

.btn-pendiente {
  background-color: #d18f00;
  color: white;
}

.btn-pendiente:hover {
  background-color: #b97900;
  color: white;
}

.alert {
  font-size: 0.95rem;
}
</style>